import { Box, Divider, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, {
  useEffect,
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react';
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  SortDirection,
} from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useStore } from '../../utils/store';
import DeleteForeverIcon from '@mui/icons-material/Delete';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';

import ButtonComponent from '../../components/form/ButtonComponent';

import AlertMessageComponent from '../../components/AlertMessageComponent';
import TextFieldComponent from '../../components/form/TextFieldComponent';
import AddButtonComponent from '../../components/form/AddButtonComponent';

import PaginateDataModel from '../../Models/PaginateDataModel';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';
import CrewLabourListComponent from '../DataManagement/Crews/parts/LaboursList';
import TextFieldAreaComponent from '../../components/form/TextFieldAreaComponent';
import ShiftSaveButtons from './parts/SaveButtons';
import tabStore from './tabStore';

interface LaboursProps {
  currentRecord: any;

  goBack: () => void;
  goRefresh: () => void;
  updateShiftStatus: (record: any) => void;
}
export type LabourRef = {
  handleSave: (type: any) => void;
};
const Labours = forwardRef<LabourRef, LaboursProps>(
  ({ currentRecord, goBack, goRefresh, updateShiftStatus }, ref) => {
    const isInitialLoad = useRef(true);
    const [laboursList, setLaboursList] = useState<any[]>([]);
    const [inProgress, setInProgress] = useState(false);
    const [currentNote, setCurrentNote] = useState<string>('');
    const [addNoteDialogOpen, setAddNoteDialogOpen] = useState<boolean>(false);
    const [addDialogOpen, setAddDialogOpen] = useState<boolean>(false);
    const [searchQuery, setSearchQuery] = useState<any>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [currentNoteIndex, setCurrentNoteIndex] = useState<number>(-1);
    const [shiftLabours, setShiftLabours] = useState<any[]>([]);
    const [selectedListIds, setSelectedListIds] = useState<any>([]);
    const [selectedList, setSelectedList] = useState<any>([]);
    const [processing, setProcessing] = useState<boolean>(false);
    const [publishing, setPublishing] = useState<boolean>(false);

    const [paginate, setPaginate] = useState<PaginateDataModel>({
      limit: Constants.DEFAULT_PAGE_SIZE,
      offset: 0,
    });
    const [orderBy, setOrderBy] = useState<any>('firstName');
    const [order, setOrder] = useState<SortDirection>('asc');
    const handleOrderBy = (orderByColumn: any) => {
      setOrderBy(orderByColumn);
      // console.log(order);
      // console.log(orderByColumn);
      if (order === 'desc') {
        setOrder('asc');
        return;
      } else {
        setOrder('desc');
        return;
      }
    };
    const handlePagination = (paginationData: any) =>
      setPaginate(paginationData);

    const { getAdmin } = useStore();
    useImperativeHandle(ref, () => ({
      handleSave,
    }));
    const [httpError, setHttpError] = useState({
      message: '',
      open: false,
    });

    const loadData = async () => {
      if (currentRecord) {
        setInProgress(true);

        handleRecords();
        setInProgress(false);
      }
    };

    const calculateTimeDiff = (start: any, end: any) => {
      if (start && end) {
        const [startH, startM] = start.split(':').map(Number);
        const [endH, endM] = end.split(':').map(Number);

        let startMinutes = startH * 60 + startM;
        let endMinutes = endH * 60 + endM;

        // if end time is smaller, assume it’s next day
        if (endMinutes < startMinutes) {
          endMinutes += 24 * 60;
        }

        const diff = endMinutes - startMinutes;
        const hours = Math.floor(diff / 60);
        const minutes = diff % 60;

        return `${hours}h ${minutes}m`;
      } else {
        return `-`;
      }
    };
    const fetchLabourList = async () => {
      try {
        setInProgress(true);
        const response = await HttpServices.get(
          `${Constants.apiURL + Constants.labourURL}`,
          { headers: { Authorization: `Bearer ${getAdmin()}` } },
          { limit: -1, serach: '' }
        );
        console.log(response);
        if (response.data) {
          // Filter to only include active labourers (status === '1')
          const activeLabours = response.data.paginateRecords.filter(
            (labour: any) => labour.status === '1'
          );
          setLaboursList(activeLabours);
          setTotalRecords(activeLabours.length);
        } else {
          setLaboursList([]);
        }
        setInProgress(false);
      } catch (error: any) {
        console.error(`Error fetching data:`, error);
        setHttpError({
          message: error.message,

          open: true,
        });
      }
    };
    const handleRecords = () => {
      let shiftLabours: any[] = currentRecord.shiftLabours;
      const idArray = currentRecord.shiftLabours.map(
        (item: any) => item.labour.id
      );
      //  console.log(idArray, '<<<<<<<<<<<<<<<<<');
      setSelectedListIds(idArray);
      shiftLabours = shiftLabours.map((item) => ({
        ...item,
        planTotalTime: calculateTimeDiff(item.planStartTime, item.planEndTime),
        actualTotalTime: calculateTimeDiff(
          item.actualStartTime,
          item.actualEndTime
        ),
        reviewStartTime:
          item.reviewStartTime === '00:00:00' &&
          item.reviewEndTime === '00:00:00'
            ? '-'
            : item.reviewStartTime,
        reviewEndTime:
          item.reviewEndTime === '00:00:00' &&
          item.reviewStartTime === '00:00:00'
            ? '-'
            : item.reviewEndTime,
        reviewTotalTime: calculateTimeDiff(
          item.reviewStartTime,
          item.reviewEndTime
        ),
      }));

      setShiftLabours(shiftLabours);
    };
    useEffect(() => {
      if (currentRecord) {
        loadData();
      }
    }, [currentRecord]);
    useEffect(() => {
      if (isInitialLoad.current) {
        if (laboursList.length === 0) fetchLabourList();
        isInitialLoad.current = false;
      }
    }, [paginate]);
    const handleStatus = (row: any) => {
      handleSelectedIds(row.id);
    };
    const handleSelectedIds = async (id: any) => {
      console.log(id);

      setSelectedListIds((prevItems: any) => {
        const newItems = [...prevItems];
        if (!newItems.includes(id)) {
          newItems.push(id);
        } else {
          newItems.splice(newItems.indexOf(id), 1);
        }
        return newItems;
      });
    };
    const handleNoteSave = async () => {
      if (currentNoteIndex !== -1) {
        tabStore.updateField('tab1Field', 'updated');
        setShiftLabours((prevItems) => {
          // Create a copy of the current state
          const updatedItems = [...prevItems];
          updatedItems[currentNoteIndex] = {
            ...updatedItems[currentNoteIndex],
            ['labourNote']: currentNote,
          };

          return updatedItems;
        });
        setAddNoteDialogOpen(false);
        setCurrentNoteIndex(-1);
        setCurrentNote('');
      }
    };
    const NoteDialogContent = () => {
      return (
        <div className="row mb-3 mt-2">
          <div style={{ width: '600px' }}>
            <TextFieldAreaComponent
              name={'notebox'}
              value={currentNote}
              isRequired={false}
              errorStr={''}
              minRows={7}
              keyName={'notebox'}
              label="Note"
              onChange={(e: any) => {
                setCurrentNote(e.target.value);
              }}
            />
          </div>
          <div className="col" style={{ textAlign: 'right' }}>
            <ButtonComponent
              keyName={'addBtn'}
              errors={[]}
              onClick={() => {
                handleNoteSave();
              }}
              loading={false}
              label={'Save'}
            />
          </div>
        </div>
      );
    };

    const handleSaveLabours = async () => {
      let filterData: any[] = laboursList.filter(
        (item) => selectedListIds.indexOf(item.id) !== -1
      );
      console.log(filterData);
      const mapped = filterData.map((labour: any) => ({
        shiftLabourId: 0,
        shiftId: currentRecord.shiftId,
        labourId: labour.id,
        planStartTime: currentRecord.shiftStatusId === 2 ? null : '09:00:00',
        planEndTime: currentRecord.shiftStatusId === 2 ? null : '17:00:00',
        actualStartTime: null,
        actualEndTime: null,
        reviewStartTime: null,
        reviewEndTime: null,
        reviewTotalTime: '-',
        planTotalTime: '8hrs 0m',
        actualTotalTime: '-',
        labourNote: '',
        status: labour.status,
        labour: {
          id: labour.id,
          firstName: labour.firstName,
          lastName: labour.lastName,
          email: labour.email,
          phoneNumber: labour.phoneNumber,
          employeeType: labour.employeeType,
          contractorId: labour.contractorId,
          jobRoleId: labour.jobRoleId,
          isHired: Boolean(labour.isHired),
          costPerHour: labour.costPerHour,
        },
      }));

      const existingShiftSelectedIds = shiftLabours.filter(
        (item: any) => selectedListIds.indexOf(item.labourId) !== -1
      );

      const existingIds = existingShiftSelectedIds.map((item) => item.labourId);

      const newItems = mapped.filter(
        (item) => !existingIds.includes(item.labourId)
      );

      const updatedItems = [...existingShiftSelectedIds, ...newItems];
      tabStore.updateField('tab1Field', 'updated');
      setShiftLabours(updatedItems);
    };
    const handleSave = async (type: number) => {
      if (type === 0) {
        setProcessing(true);
      } else {
        setPublishing(true);
      }
      tabStore.updateField('tab1Field', '');
      const finalItems: any = shiftLabours.map((item: any) => ({
        labourId: item.labourId,
        planStartTime: item.planStartTime,
        planEndTime: item.planEndTime,
        actualStartTime: item.actualStartTime,
        actualEndTime: item.actualEndTime,
        reviewStartTime: item.reviewStartTime,
        reviewEndTime: item.reviewEndTime,
        labourNote: item.labourNote,
      }));
      const shiftReq: any = {
        shiftId: currentRecord.shiftId,
        labours: finalItems,
      };

      const endpoint = Constants.apiURL + Constants.shiftURL + '/labours';

      let response: any;

      try {
        if (currentRecord) {
          response = await HttpServices.post(endpoint, shiftReq, {
            headers: { Authorization: `Bearer ${getAdmin()}` },
          });
        }
        setHttpError({
          open: true,
          message: type === 0 ? 'Saved' : 'Saved successfully',
        });
        if (type === 1) {
          goBack();
        }
        if (type === 3 || type === 4 || type === 1) {
          updateShiftStatus({
            shiftId: currentRecord.shiftId,
            newShiftStatusId: type,
          });
          if (type === 4 || type === 1) {
            goBack();
          }
          return true;
        } else {
          goRefresh();
          return true;
        }
      } catch (error: any) {
        console.error(`PATCH Error:`, error);
        setHttpError({
          message: error.message,
          open: true,
        });
        return true;
      } finally {
        setProcessing(false);
        setPublishing(false);
        return true;
      }
    };
    const removeItem = (index: any) => {
      tabStore.updateField('tab1Field', 'updated');
      setSelectedListIds((prevIds: number[]) =>
        prevIds.filter((id) => id !== shiftLabours[index]['labourId'])
      );
      setShiftLabours((prevItems) => {
        const newItems = [...prevItems];
        newItems.splice(index, 1);

        return newItems;
      });
    };
    const formatTime = (time: string): string => {
      return time ? time.replace(/^(\d{2}:\d{2}):\d{2}$/, '$1') : '-';
    };
    const LabourDialogContent = () => {
      return (
        <Box className="row mb-3 mt-2" sx={{ textAlign: 'right' }}>
          <Typography component={'h1'} sx={{ mt: 4, mb: 4, textAlign: 'left' }}>
            Add Labourers
          </Typography>
          <Box sx={{ width: '800px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
                mt: 2,
              }}
            ></Box>
            <CrewLabourListComponent
              handleStatus={handleStatus}
              recordList={laboursList}
              selectedRecords={selectedListIds}
              totalRecords={totalRecords}
              paginate={paginate}
              handlePagination={handlePagination}
              order={order}
              orderBy={orderBy}
              handleOrderBy={handleOrderBy}
            ></CrewLabourListComponent>
          </Box>
          <Button
            color="primary"
            sx={{ color: '#fff !important', mt: 3, mb: 3, textAlign: 'right' }}
            variant="contained"
            onClick={() => {
              handleSaveLabours();
              setAddDialogOpen(false);
            }}
          >
            Save
          </Button>
        </Box>
      );
    };
    const calculateTotalTime = (startTime: any, endTime: any) => {
      if (startTime && endTime) {
        const [startHours, startMinutes] = startTime.split(':').map(Number);
        const [endHours, endMinutes] = endTime.split(':').map(Number);

        let start: any = new Date();
        start.setHours(startHours, startMinutes, 0);

        let end: any = new Date();
        end.setHours(endHours, endMinutes, 0);

        let diff = (end - start) / 1000 / 60; // difference in minutes

        if (diff < 0) diff += 24 * 60; // handles endTime being next day

        const hours = Math.floor(diff / 60);
        const minutes = Math.ceil(diff % 60);

        return `${hours}hrs, ${minutes}min `;
      } else {
        return '--';
      }
    };
    const handleTimeChange = (value: any, index: number, type: string) => {
      setShiftLabours((prevItems) => {
        // Create a copy of the current state
        const updatedItems = [...prevItems];

        if (
          type === 'planStartTime' ||
          type === 'planEndTime' ||
          type === 'reviewStartTime' ||
          type === 'reviewEndTime'
        ) {
          let calculatedType = 'planTotalTime';
          let totalTime = '-';
          if (type === 'planStartTime' || type === 'planEndTime') {
            if (type === 'planStartTime') {
              totalTime = calculateTotalTime(
                value,
                updatedItems[index]['planEndTime']
              );
            }
            if (type === 'planEndTime') {
              totalTime = calculateTotalTime(
                updatedItems[index]['planStartTime'],
                value
              );
            }
            calculatedType = 'planTotalTime';
          }
          if (type === 'reviewStartTime' || type === 'reviewEndTime') {
            if (type === 'reviewStartTime') {
              totalTime = calculateTotalTime(
                value,
                updatedItems[index]['reviewEndTime']
              );
            }
            if (type === 'reviewEndTime') {
              totalTime = calculateTotalTime(
                updatedItems[index]['reviewStartTime'],
                value
              );
            }
            calculatedType = 'reviewTotalTime';
          }
          updatedItems[index] = {
            ...updatedItems[index],
            [type]: value,
            [calculatedType]: totalTime,
          };
        } else {
          updatedItems[index] = {
            ...updatedItems[index],
            [type]: value,
          };
        }
        return updatedItems;
      });
      tabStore.updateField('tab1Field', 'updated');
    };
    return (
      <Paper sx={{ width: '100%' }} elevation={0} className="mt-4">
        <Box
          sx={{
            padding: '24px 16px 16px 16px',
            mb: 2,
            display: 'grid',
            gap: '32px',
          }}
        >
          <Grid size={12} sx={{ gap: 20, marginTop: '35px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                mb: 2,
              }}
            >
              <Typography variant="h6">Labours</Typography>
              {(currentRecord.shiftStatusId === 0 ||
                currentRecord.shiftStatusId === 2) && (
                <AddButtonComponent
                  onClick={() => {
                    setAddDialogOpen(true);
                  }}
                  keyName="quoteaddicon"
                  label="Add New"
                />
              )}
            </Box>
            {shiftLabours.length > 0 && (
              <TableContainer sx={{ mt: 2 }} component={Paper}>
                <Table className="">
                  <TableRow
                    className="headrowtbl"
                    key={'headrow_'}
                    style={{ background: ' rgba(0, 244, 255, 0.06)' }}
                  >
                    <TableCell key={'tblheadcllitemc_'} className="boldfont">
                      Name
                    </TableCell>
                    <TableCell
                      key={'tblbotblheadclliqty_'}
                      className="boldfont"
                      style={{ width: '100px' }}
                    >
                      Plan Start Time
                    </TableCell>
                    <TableCell
                      key={'tblbotblheadcllistarttime_'}
                      className="boldfont"
                      style={{ width: '' }}
                    >
                      Plan End Time
                    </TableCell>
                    <TableCell
                      key={'tblbotblheadcllistarttime_plantotaltime'}
                      className="boldfont"
                      style={{ width: '' }}
                    >
                      Plan Total Time
                    </TableCell>
                    <TableCell
                      key={'tblbotblheadclactstarttime'}
                      className="boldfont"
                      style={{ width: '100px' }}
                    >
                      Actual Start Time
                    </TableCell>
                    <TableCell
                      key={'tblbotblheadcllistarttime_Actual'}
                      className="boldfont"
                      style={{ width: '' }}
                    >
                      Actual End Time
                    </TableCell>
                    <TableCell
                      key={'tblbotblheadcllistarttime_Actual_total_time'}
                      className="boldfont"
                      style={{ width: '' }}
                    >
                      Actual Total Time
                    </TableCell>

                    <TableCell
                      key={'tblbotblheadclliqty_Review'}
                      className="boldfont"
                      style={{ width: '100px' }}
                    >
                      Review Start Time
                    </TableCell>
                    <TableCell
                      key={'tblbotblheadcllistarttime_Review'}
                      className="boldfont"
                      style={{ width: '' }}
                    >
                      Review End Time
                    </TableCell>
                    <TableCell
                      colSpan={2}
                      className="boldfont"
                      style={{ textAlign: 'center' }}
                    >
                      Review Total Time
                    </TableCell>
                  </TableRow>
                  {shiftLabours.map((item: any, index: any) => {
                    return (
                      <TableBody key={'tblbody_' + index}>
                        <TableRow>
                          <TableCell>
                            {`${item.labour.firstName} ${item.labour.lastName}`}
                          </TableCell>
                          <TableCell>
                            {currentRecord.shiftStatusId === 0 && (
                              <TextFieldComponent
                                label=""
                                keyName={'labours_plan_start_time' + index}
                                name={'labours_plan_start_time' + index}
                                value={item.planStartTime}
                                onChange={(event) => {
                                  handleTimeChange(
                                    event.target.value,
                                    index,
                                    'planStartTime'
                                  );
                                }}
                                errorStr={''}
                                type="time"
                                isRequired={false}
                              />
                            )}
                            {currentRecord.shiftStatusId !== 0 && (
                              <Box sx={boxStyle}>
                                {formatTime(item.planStartTime)}
                              </Box>
                            )}
                          </TableCell>
                          <TableCell>
                            {currentRecord.shiftStatusId === 0 && (
                              <TextFieldComponent
                                label=""
                                keyName={'labours_plan_end_time' + index}
                                name={'labours_plan_end_time' + index}
                                value={item.planEndTime}
                                onChange={(event) => {
                                  handleTimeChange(
                                    event.target.value,
                                    index,
                                    'planEndTime'
                                  );
                                }}
                                errorStr={''}
                                type="time"
                                isRequired={false}
                              />
                            )}
                            {currentRecord.shiftStatusId !== 0 && (
                              <Box sx={boxStyle}>
                                {formatTime(item.planEndTime)}
                              </Box>
                            )}
                          </TableCell>

                          <TableCell>
                            <Box sx={boxStyle}>
                              {item.planTotalTime === '00:00:00'
                                ? '-'
                                : item.planTotalTime}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={boxStyle}>
                              {item.actualStartTime === '00:00:00'
                                ? '-'
                                : formatTime(item.actualStartTime)}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={boxStyle}>
                              {item.actualEndTime === '00:00:00'
                                ? '-'
                                : formatTime(item.actualEndTime)}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={boxStyle}>
                              {item.actualTotalTime === '0h 0m'
                                ? '-'
                                : item.actualTotalTime}
                            </Box>
                          </TableCell>
                          <TableCell>
                            {(currentRecord.shiftStatusId === 2 ||
                              currentRecord.shiftStatusId === 3) && (
                              <TextFieldComponent
                                label=""
                                keyName={'labours_review_start_time' + index}
                                name={'labours_review_start_time' + index}
                                value={item.reviewStartTime}
                                onChange={(event) => {
                                  handleTimeChange(
                                    event.target.value,
                                    index,
                                    'reviewStartTime'
                                  );
                                }}
                                errorStr={''}
                                type="time"
                                isRequired={false}
                              />
                            )}
                            {currentRecord.shiftStatusId !== 2 &&
                              currentRecord.shiftStatusId !== 3 && (
                                <Box sx={boxStyle}>
                                  {item.reviewStartTime === '00:00:00'
                                    ? '-'
                                    : formatTime(item.reviewStartTime)}
                                </Box>
                              )}
                          </TableCell>
                          <TableCell>
                            {(currentRecord.shiftStatusId === 2 ||
                              currentRecord.shiftStatusId === 3) && (
                              <TextFieldComponent
                                label=""
                                keyName={'labours_review_end_time' + index}
                                name={'labours_review_end_time' + index}
                                value={item.reviewEndTime}
                                onChange={(event) => {
                                  handleTimeChange(
                                    event.target.value,
                                    index,
                                    'reviewEndTime'
                                  );
                                }}
                                errorStr={''}
                                type="time"
                                isRequired={false}
                              />
                            )}
                            {currentRecord.shiftStatusId !== 2 &&
                              currentRecord.shiftStatusId !== 3 && (
                                <Box sx={boxStyle}>
                                  {item.reviewEndTime === '00:00:00'
                                    ? '-'
                                    : formatTime(item.reviewEndTime)}
                                </Box>
                              )}
                          </TableCell>
                          <TableCell>
                            <Box sx={boxStyle}>
                              {item.reviewTotalTime === '0h 0m'
                                ? '-'
                                : item.reviewTotalTime}
                            </Box>
                          </TableCell>
                          {
                            <TableCell style={{ width: '100px' }}>
                              {currentRecord.shiftStatusId === 0 && (
                                <IconButton
                                  aria-label="delete"
                                  onClick={() => {
                                    removeItem(index);
                                  }}
                                  sx={boxStyle}
                                >
                                  <DeleteForeverIcon />
                                </IconButton>
                              )}
                              <IconButton
                                onClick={() => {
                                  setCurrentNoteIndex(index);
                                  setCurrentNote(
                                    shiftLabours[index]['labourNote']
                                  );
                                  setAddNoteDialogOpen(true);
                                }}
                                sx={boxStyle}
                              >
                                <EditNoteIcon
                                  sx={{
                                    color: item.labourNote ? '#00e5ff' : '#000',
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          }
                        </TableRow>
                      </TableBody>
                    );
                  })}

                  {/* </TableBody> */}
                </Table>
              </TableContainer>
            )}
          </Grid>
          <Divider />
          <ShiftSaveButtons
            processing={processing}
            publishing={publishing}
            handleSave={handleSave}
            shiftStatus={currentRecord ? currentRecord.shiftStatusId : 0}
          />

          <SimpleDialogComponent
            title={''}
            dialogContent={LabourDialogContent()}
            open={addDialogOpen}
            handleClose={() => {
              setAddDialogOpen(false);
            }}
          />
          <AlertMessageComponent
            type={'success'}
            open={httpError.open}
            handleClose={() => {
              setHttpError({ open: false, message: '' });
            }}
            message={httpError.message}
          />
          {
            <SimpleDialogComponent
              title={'Billable Note'}
              dialogContent={NoteDialogContent()}
              open={addNoteDialogOpen}
              handleClose={() => {
                setAddNoteDialogOpen(false);
              }}
            />
          }
        </Box>
      </Paper>
    );
  }
);

export default Labours;
const boxStyle = {
  marginBottom: '15px',
};
